<template>
<div v-if="$route.name !== 'home'">
  <v-layout row justify-end>
    <v-dialog v-model="displayModal2" max-width="700">
      <v-btn flat slot="activator" color="green lighten-2" light>
        <v-icon class="mr-1" small>add_box</v-icon> Add Post</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Add Post</span>
        </v-card-title>
        <v-card-text class="text-xs-left">
          <v-text-field v-validate="'required'" :error-messages="errors.collect('newArticle')" data-vv-name="newArticle" color="green" v-model="newArticle" label="Title" class="text-input" required />
          <markdown-editor v-validate="'required'" :error-messages="errors.collect('description')" data-vv-name="description" class="text-xs-left" color="green" v-model="description" :configs="configs" required />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="clearValid()">
            Cancel
          </v-btn>
          <v-btn color="green lighten-2" flat @click="addArticle">
            Add Post
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-card flat tile class="text-xs-left mb-2" v-for="(article, idx) in articles" :key="idx">
    <v-card-text>
      <a style="float:right" small fab flat color="red" @click="openDelete(article.id)">
        <v-icon color="red">delete</v-icon>
      </a>
      <a class="mr-2" style="float:right" small fab flat color="green" @click="openEdit(article.id, article.text, article.description)">
        <v-icon color="green">edit</v-icon>
      </a>
      <h2 class="mb-2"><v-icon>description</v-icon> {{article.text}}</h2>
      <vue-markdown :source="article.description"></vue-markdown>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <p class="caption">By
        <v-icon small>perm_identity</v-icon> {{ article.author }} -
        <v-icon small>today</v-icon> {{ article.createdAt }}</p>
    </v-card-actions>
    <v-dialog v-model="removePost" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Post</span>
        </v-card-title>
        <v-card-text>
          <p>Are you sure you want to permanently delete this post?</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="removePost = false">
            Cancel
          </v-btn>
          <v-btn color="red" outline @click="deleteArticle(article.id)">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editPost" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Post</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Title" v-model="editDetails.text" color="green" class="text-input" required />
          <markdown-editor class="text-xs-left" color="green" v-model="editDetails.description" :configs="configs" required />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="editPost = false">
            Cancel
          </v-btn>
          <v-btn color="green lighten-2" flat @click="editArticle(article.id)">
            Update Post
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</div>
<div v-else class="py-0 my-0">
  <v-layout align-center justify-space-between row wrap class="mb-0">
    <v-flex xs12 sm8 offset-sm4 offset-md4 class="text-xs-right">
      <p class="mb-0 d-inline green--text text--lighten-1"><strong>Latest Post</strong></p>
      <v-btn small flat color="green lighten-2" :to="{ name: 'posts' }" light>View All</v-btn>
    </v-flex>
  </v-layout>
  <v-card flat tile class="text-xs-left mt-0 mb-2" v-for="(article, idx) in articles" :key="idx" v-if="idx < 1" style="max-height:230px;overflow-y: scroll;">
    <v-card-text>
      <h2 class="mb-2"><v-icon>description</v-icon> {{article.text}}</h2>
      <vue-markdown :source="article.description"></vue-markdown>
    </v-card-text>
  </v-card>
</div>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import {
  getUserData
} from "@/scripts/userFuncs";
import firebase, {
  FirebaseConsts,
  db
} from "@/firebaseConfig";
import moment from 'moment'
export default {
  name: "Article",
  components: {
    VueMarkdown
  },
  data() {
    return {
      articles: [],
      newArticle: '',
      text: '',
      description: '',
      displayModal2: false,
      editPost: false,
      removePost: false,
      toggle_none: 0,
      editDetails: {
        id: '',
        text: '',
        description: ''
      },
      dictionary: {
        custom: {
          newArticle: {
            required: () => 'Title can not be empty',
            // custom messages
          },
          description: {
            required: () => 'Description can not be empty',
            // custom messages
          }
        }
      },
      configs: {
        toolbar: ['bold', 'italic', 'heading', '|', 'ordered-list', 'unordered-list', '|', 'quote', 'horizontal-rule', '|', 'link', 'image', 'code']
      }
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    addArticle() {
      this.$validator.validateAll()
      var article = this.newArticle.trim();
      if (article) {
        db.collection("projects")
          .doc(this.$route.params.groupID)
          .collection("articles")
          .add({
            createdAt: moment().format('MMM Do YYYY, h:mm:ss a'),
            author: this.user.displayName,
            text: article,
            description: this.description
          }).then(ref => {
            this.displayModal2 = false;
            this.newArticle = "";
            this.description = "";
            this.$validator.reset();
          }).catch(err => {
            console.log(err)
          });
      }
    },
    openEdit(id, text, description) {
      this.editPost = true
      this.editDetails.id = id
      this.editDetails.text = text
      this.editDetails.description = description
    },
    editArticle(id) {
      var id = this.editDetails.id;
      db.collection("projects").doc(this.$route.params.groupID).collection('articles').doc(id).update({
        text: this.editDetails.text,
        description: this.editDetails.description
      }).then(ref => {
        this.editPost = false
      }).catch(err => {
        console.log(err)
      });
    },
    openDelete(id) {
      this.removePost = true
      this.editDetails.id = id
    },
    deleteArticle(id) {
      var id = this.editDetails.id;
      db.collection("projects").doc(this.$route.params.groupID).collection('articles').doc(id).delete()
      this.removePost = false
    },
    clearValid() {
      this.displayModal2 = false;
      this.$validator.reset();
    },
    loadGroupArticles() {
      this.$bind(
        "articles",
        db
        .collection("projects")
        .doc(this.$route.params.groupID)
        .collection("articles")
        .orderBy("createdAt", "desc")
      ).then(articles => {
        this.articles === articles;
      });
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.$store.commit("setUID", user.uid);

        this.$bind("firestoreUser", db.collection("users").doc(user.uid)).then(
          user => {
            this.firestoreUser === user;
          }
        );
      } else {
        this.user = null;
      }
    });
    this.editDetails.text = this.text
    this.editDetails.description = this.description
    this.loadGroupArticles();
  },
  filters: {
    getDate(value) {
      return moment(String(value)).format('MMM Do, YYYY hh:mm a')
    }
  },
  watch: {
    // Reload the group's messages when the user switches groups
    "$route.params.groupID" (id) {
      this.loadGroupArticles();
    }
  }
};
</script>

<style lang="scss">
.v-input input {
    width: 100%;
    min-width: 100vw;
}
.ql-toolbar.ql-snow {
    background: #f2f2f2;
    background-color: #f2f2f2;
}
blockquote {
    position: relative;
    padding-left: 1.2rem;
    border-left: 0.5rem solid #66bb6a;
    font-size: 14px;
    line-height: 1.5rem;
}
blockquote:before {
    content: '\201C';
    position: absolute;
    left: 0.2rem;
    font-size: 2rem;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Posts/Article.vue